import React from 'react';
import { checkRole } from '../Common/CheckRole';

const Button = ({ showHideButton, openPopupSectionUIHandler }) => (
  <div className="container_fluid pad15 topheading">
    <div className="row">
      <div className="col-xs-12 col-md">
        <div className="d-full-height justify-content-center fnt18 tu pad_top_bot3"> RATE INVENTORY</div>
      </div>
      <div className="col-xs-12 col-sm">
        <div className="row gutters-5 justify-content-end height100">
          {(showHideButton.stopSale === 1 && checkRole('property_stop_sale')) ? (
            <div
              className="col-xs-auto"
              onClick={event => openPopupSectionUIHandler(event, 'stopsale')}
            >
              <span className="cursor_p disblock btn1 pad_top_bot6 pad_lft_rht10 pop_clk"> STOP SALE</span>
            </div>
          ) : ''}
          {(showHideButton.startSale === 1 && checkRole('property_stop_sale')) ? (
            <div
              className="col-xs-auto"
              onClick={event => openPopupSectionUIHandler(event, 'startsale')}
            >
              <span className="cursor_p disblock btn1 pad_top_bot6 pad_lft_rht10 pop_clk"> START SALE</span>
            </div>
          ) : ''}
          {showHideButton.updateRate === 1 ? (
            <div
              className="col-xs-auto"
              onClick={event => openPopupSectionUIHandler(event, 'updaterate')}
            >
              <span className="cursor_p disblock btn1 pad_top_bot6 pad_lft_rht10 pop_clk">UPDATE RATE</span>
            </div>
          ) : ''}
        </div>
      </div>
    </div>
  </div>
);

export default Button;
